/* Science-page interactions. No storage APIs or third-party dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initializeStudies(root) {
    root.querySelectorAll('[data-ka-science-studies]').forEach(function (database) {
      if (database.dataset.kaScienceReady === 'true') return;
      database.dataset.kaScienceReady = 'true';

      var page = database.closest('#ka-science') || document;
      var studies = Array.prototype.slice.call(database.querySelectorAll('[data-ka-study]'));
      var count = database.querySelector('[data-ka-study-count]');
      var noResults = database.querySelector('[data-ka-study-empty]');
      var filterSearch = database.querySelector('[data-ka-study-search]');
      var areaSelect = database.querySelector('[data-ka-study-area]');
      var resultSelect = database.querySelector('[data-ka-study-result]');
      var suppliedToggle = database.querySelector('[data-ka-study-supplied]');
      var clearButton = database.querySelector('[data-ka-study-clear]');
      var heroInput = page.querySelector('[data-ka-science-hero-search]');
      var heroButton = page.querySelector('[data-ka-science-hero-search-button]');
      var state = { area: 'all', result: 'all', supplied: false, search: '' };

      function apply() {
        var visible = 0;
        studies.forEach(function (study) {
          var areas = (study.dataset.area || '').split(/\s+/);
          var result = study.dataset.result || 'neutral';
          var supplied = study.dataset.ka === 'true';
          var searchable = ((study.dataset.text || '') + ' ' + study.textContent).toLowerCase();
          var show = (state.area === 'all' || areas.indexOf(state.area) !== -1) &&
            (state.result === 'all' || result === state.result) &&
            (!state.supplied || supplied) &&
            (!state.search || searchable.indexOf(state.search.toLowerCase().trim()) !== -1);
          study.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = visible;
        if (noResults) noResults.hidden = visible !== 0;
      }

      function setSearch(value, source) {
        state.search = value || '';
        if (filterSearch && source !== 'filter') filterSearch.value = state.search;
        if (heroInput && source !== 'hero') heroInput.value = state.search;
        apply();
      }

      if (areaSelect) areaSelect.addEventListener('change', function () {
        state.area = areaSelect.value;
        apply();
      });
      if (resultSelect) resultSelect.addEventListener('change', function () {
        state.result = resultSelect.value;
        apply();
      });
      if (filterSearch) filterSearch.addEventListener('input', function () {
        setSearch(filterSearch.value, 'filter');
      });
      if (heroInput) {
        heroInput.addEventListener('input', function () { setSearch(heroInput.value, 'hero'); });
        heroInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' && heroButton) heroButton.click();
        });
      }
      if (heroButton) heroButton.addEventListener('click', function () {
        setSearch(heroInput ? heroInput.value : '', 'hero');
        database.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
      if (suppliedToggle) suppliedToggle.addEventListener('click', function () {
        state.supplied = !state.supplied;
        suppliedToggle.classList.toggle('active', state.supplied);
        suppliedToggle.setAttribute('aria-pressed', state.supplied ? 'true' : 'false');
        apply();
      });
      if (clearButton) clearButton.addEventListener('click', function () {
        state = { area: 'all', result: 'all', supplied: false, search: '' };
        if (areaSelect) areaSelect.value = 'all';
        if (resultSelect) resultSelect.value = 'all';
        if (filterSearch) filterSearch.value = '';
        if (heroInput) heroInput.value = '';
        if (suppliedToggle) {
          suppliedToggle.classList.remove('active');
          suppliedToggle.setAttribute('aria-pressed', 'false');
        }
        apply();
      });
      apply();
    });
  }

  function initializeConcentration(root) {
    root.querySelectorAll('[data-ka-science-concentration]').forEach(function (module) {
      if (module.dataset.kaScienceReady === 'true') return;
      var range = module.querySelector('input[type="range"]');
      var output = module.querySelector('[data-ka-science-concentration-output]');
      var thumb = module.querySelector('[data-ka-science-concentration-thumb]');
      var ladder = module.querySelector('[data-ka-swipe-track]');
      var swipeHint = module.querySelector('[data-ka-swipe-hint]');
      var swipePrevious = swipeHint ? swipeHint.querySelector('[data-ka-swipe-prev]') : null;
      var swipeNext = swipeHint ? swipeHint.querySelector('[data-ka-swipe-next]') : null;
      var swipeStatus = swipeHint ? swipeHint.querySelector('[data-ka-swipe-status]') : null;
      var rungs = Array.prototype.slice.call(module.querySelectorAll('.ladder .rung'));
      if (!range || !output || rungs.length === 0) return;
      module.dataset.kaScienceReady = 'true';
      var mobileLayout = window.matchMedia('(max-width: 760px)');
      var scrollTimer;
      var concentration = module.querySelector('.conc');
      var concentrationName = concentration ? concentration.dataset.concentrationName : 'Veech Ketone Ester';
      var values = rungs.map(function (rung) {
        return {
          pct: rung.dataset.rangeLabel || '',
          per: rung.dataset.rangeNote || '',
          emoji: rung.dataset.rangeEmoji || ''
        };
      });

      function updateSwipeHint(index) {
        if (!swipeHint) return;
        var hasPrevious = index > 0;
        var hasNext = index < rungs.length - 1;
        if (swipePrevious) swipePrevious.hidden = !hasPrevious;
        if (swipeNext) swipeNext.hidden = !hasNext;
        if (swipeStatus) {
          var instruction = hasPrevious && hasNext
            ? 'Swipe left or right to view another product.'
            : hasNext
              ? 'Swipe left to view the next product.'
              : 'Swipe right to view the previous product.';
          swipeStatus.textContent = 'Product ' + (index + 1) + ' of ' + rungs.length + '. ' + instruction;
        }
      }

      function scrollToRung(index) {
        if (!ladder || !mobileLayout.matches || !rungs[index]) return;
        var firstOffset = rungs[0].offsetLeft;
        ladder.scrollTo({
          left: rungs[index].offsetLeft - firstOffset,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      function apply(scrollCard) {
        var index = Math.max(0, Math.min(values.length - 1, parseInt(range.value, 10) || 0));
        var item = values[index];
        var percentage = document.createElement('b');
        var note = document.createElement('span');
        percentage.textContent = item.pct;
        note.textContent = item.per;
        output.replaceChildren(percentage, document.createTextNode(' ' + concentrationName + ' · '), note);
        if (thumb) {
          thumb.textContent = item.emoji;
          var denominator = Math.max(values.length - 1, 1);
          thumb.style.left = 'calc(' + ((index / denominator) * 100) + '% + ' + (24 - (index / denominator) * 48) + 'px)';
        }
        rungs.forEach(function (rung, rungIndex) {
          var selected = rungIndex === index;
          var image = rung.querySelector('.rungImg');
          rung.classList.toggle('win', selected);
          if (image) {
            var next = selected ? image.dataset.sel : image.dataset.x;
            if (next && image.getAttribute('src') !== next) image.setAttribute('src', next);
          }
        });
        updateSwipeHint(index);
        if (scrollCard) scrollToRung(index);
      }

      range.addEventListener('input', function () {
        apply(true);
      });
      rungs.forEach(function (rung, index) {
        rung.addEventListener('mouseenter', function () {
          range.value = index;
          apply(false);
        });
      });
      if (ladder) {
        ladder.addEventListener('scroll', function () {
          if (!mobileLayout.matches) return;
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function () {
            var ladderRect = ladder.getBoundingClientRect();
            var ladderCenter = ladderRect.left + ladderRect.width / 2;
            var closestIndex = 0;
            var closestDistance = Infinity;
            rungs.forEach(function (rung, index) {
              var rungRect = rung.getBoundingClientRect();
              var distance = Math.abs(rungRect.left + rungRect.width / 2 - ladderCenter);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });
            if (parseInt(range.value, 10) !== closestIndex) {
              range.value = closestIndex;
              apply(false);
            } else {
              updateSwipeHint(closestIndex);
            }
          }, 90);
        }, { passive: true });
      }
      apply(false);
    });
  }

  function initializeParallax(root) {
    if (reduceMotion) return;
    var elements = Array.prototype.slice.call(root.querySelectorAll('[data-parallax], .bgMark, .profileMark, .founderMark, .founderBottle'));
    elements = elements.filter(function (element) {
      if (element.dataset.kaScienceParallax === 'true') return false;
      element.dataset.kaScienceParallax = 'true';
      return true;
    });
    if (elements.length === 0) return;

    var ticking = false;
    function update() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      elements.forEach(function (element) {
        var host = element.parentElement;
        var rect = host.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;
        var speed = parseFloat(element.dataset.parallax || '0.08');
        var drift = Math.max(-60, Math.min(60, (rect.top + rect.height / 2 - viewportHeight / 2) * -speed));
        if (element.classList.contains('bgMark') || element.classList.contains('profileMark')) {
          element.style.setProperty('--parallaxY', drift.toFixed(1) + 'px');
        } else if (element.classList.contains('hkGhost')) {
          element.style.transform = 'translate3d(0, calc(-50% + ' + drift.toFixed(1) + 'px), 0)';
        } else {
          element.style.transform = 'translate3d(0,' + drift.toFixed(1) + 'px,0)';
        }
      });
      ticking = false;
    }
    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  function initializeTableHints(root) {
    root.querySelectorAll('.kaMobileTableHint').forEach(function (hint) {
      if (hint.dataset.kaTableHintReady === 'true') return;
      var scroller = hint.nextElementSibling;
      if (!scroller) return;
      hint.dataset.kaTableHintReady = 'true';

      function update() {
        hint.dataset.scrollable = scroller.scrollWidth > scroller.clientWidth + 2 ? 'true' : 'false';
      }

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initialize(root) {
    initializeStudies(root);
    initializeConcentration(root);
    initializeTableHints(root);
    initializeParallax(root);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
